// extracted by mini-css-extract-plugin
module.exports = {"gridSizedTile":"GridSizedTile_gridSizedTile__25C7b"};